// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AiModuleOne_wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f6f3ec;
  box-sizing: border-box;
  font-family: 'Manrope', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
}

.AiModuleOne_content {
  width: 100%;
  max-width: 960px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.AiModuleOne_title {
  font-size: clamp(20px, 3vw, 27px);
  font-weight: 800;
  letter-spacing: -0.3px;
  color: #241f16;
  margin: 0 0 8px;
}

.AiModuleOne_subtitle {
  font-size: 13.5px;
  font-weight: 500;
  color: #8a8478;
  margin: 0 0 28px;
  line-height: 1.6;
}

/* fluid 16:9 responsive video container for the native <video> tag —
   plays whatever direct file URL your VideoHoster gives you */
.AiModuleOne_video_wrap {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  border-radius: 16px;
  overflow: hidden;
  background: #000000;
  box-shadow: 0 10px 30px rgba(28, 27, 20, 0.14);
  margin-bottom: 16px;
}

.AiModuleOne_video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: none;
  background: #000000;
}

/* ---------- WATCH PROGRESS BAR ---------- */

.AiModuleOne_progress_row {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 32px;
}

.AiModuleOne_progress_track {
  flex: 1 1;
  height: 8px;
  border-radius: 100px;
  background: #e6e3dc;
  overflow: hidden;
}

.AiModuleOne_progress_fill {
  height: 100%;
  border-radius: 100px;
  background: linear-gradient(90deg, #ff8a5c, #34c795);
  transition: width 0.4s ease;
}

.AiModuleOne_progress_label {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 800;
  color: #241f16;
  min-width: 74px;
  text-align: right;
}

/* ---------- ASSESSMENT ---------- */

.AiModuleOne_assessment {
  width: 100%;
  text-align: left;
  animation: AiModuleOne_fadeIn 0.5s ease both;
}

@keyframes AiModuleOne_fadeIn {
  from { opacity: 0; transform: translateY(14px); }
  to { opacity: 1; transform: translateY(0); }
}

.AiModuleOne_assessment_title {
  font-size: 18px;
  font-weight: 800;
  color: #241f16;
  margin: 0 0 6px;
  text-align: center;
}

.AiModuleOne_assessment_sub {
  font-size: 13px;
  font-weight: 500;
  color: #8a8478;
  margin: 0 0 24px;
  text-align: center;
}

.AiModuleOne_question_card {
  background: #ffffff;
  border-radius: 16px;
  padding: 22px 22px 24px;
  margin-bottom: 18px;
  box-shadow: 0 4px 14px rgba(28, 27, 20, 0.06);
}

.AiModuleOne_question_text {
  font-size: 14.5px;
  font-weight: 700;
  color: #241f16;
  margin: 0 0 16px;
  line-height: 1.5;
}

.AiModuleOne_question_num {
  color: #ff8a5c;
  font-weight: 800;
}

.AiModuleOne_options_grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.AiModuleOne_option_btn {
  font-family: 'Manrope', sans-serif;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  text-align: left;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1.5px solid #e6e3dc;
  background: #ffffff;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease, transform 0.15s ease;
}

.AiModuleOne_option_btn:hover:not(:disabled) {
  border-color: #ff8a5c;
  background: #fff6f1;
  transform: translateY(-2px);
}

.AiModuleOne_option_btn:disabled {
  cursor: not-allowed;
}

.AiModuleOne_option_key {
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #f6f3ec;
  color: #241f16;
  font-size: 12px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
}

.AiModuleOne_option_label {
  font-size: 13px;
  font-weight: 600;
  color: #4b5165;
}

.AiModuleOne_option_correct {
  border-color: #34c795;
  background: #eafaf3;
  animation: AiModuleOne_pop 0.3s ease;
}

.AiModuleOne_option_correct .AiModuleOne_option_key {
  background: #34c795;
  color: #ffffff;
}

.AiModuleOne_option_correct .AiModuleOne_option_label {
  color: #1f7a53;
}

.AiModuleOne_option_wrong {
  border-color: #d8455c;
  background: #fdeef0;
  animation: AiModuleOne_shake 0.35s ease;
}

.AiModuleOne_option_wrong .AiModuleOne_option_key {
  background: #d8455c;
  color: #ffffff;
}

.AiModuleOne_option_wrong .AiModuleOne_option_label {
  color: #a3293c;
}

.AiModuleOne_option_reveal {
  border-color: #34c795;
  background: #f4fbf8;
}

.AiModuleOne_option_reveal .AiModuleOne_option_key {
  background: #34c795;
  color: #ffffff;
}

@keyframes AiModuleOne_pop {
  0% { transform: scale(0.96); }
  60% { transform: scale(1.02); }
  100% { transform: scale(1); }
}

@keyframes AiModuleOne_shake {
  0% { transform: translateX(0); }
  25% { transform: translateX(-4px); }
  50% { transform: translateX(4px); }
  75% { transform: translateX(-2px); }
  100% { transform: translateX(0); }
}

/* ---------- COMPLETE BUTTON ---------- */

.AiModuleOne_complete_btn {
  font-family: 'Manrope', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  background: #34c795;
  color: #ffffff;
  border: none;
  border-radius: 100px;
  padding: 14px 30px;
  font-size: 13.5px;
  font-weight: 800;
  letter-spacing: 0.4px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-top: 8px;
  transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.25s ease, background 0.25s ease, opacity 0.25s ease;
  will-change: transform;
}

.AiModuleOne_complete_btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -60%;
  width: 50%;
  height: 100%;
  background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.5), transparent);
  transform: skewX(-20deg);
  transition: left 0.6s ease;
}

.AiModuleOne_complete_btn:hover:not(:disabled) {
  background: #241f16;
  box-shadow: 0 10px 22px rgba(36, 31, 22, 0.22);
  transform: translateY(-3px) scale(1.02);
}

.AiModuleOne_complete_btn:hover:not(:disabled)::before {
  left: 120%;
}

.AiModuleOne_complete_btn:active:not(:disabled) {
  transform: translateY(0) scale(0.98);
}

.AiModuleOne_complete_btn:disabled {
  background: #cfc9bc;
  cursor: not-allowed;
  opacity: 0.8;
}

.AiModuleOne_complete_check {
  display: inline-block;
  font-weight: 800;
}

/* ---------- RESPONSIVE ---------- */

@media (max-width: 640px) {
  .AiModuleOne_wrapper {
    padding: 36px 18px;
  }

  .AiModuleOne_video_wrap {
    border-radius: 12px;
  }

  .AiModuleOne_options_grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 420px) {
  .AiModuleOne_question_card {
    padding: 18px 16px 20px;
  }

  .AiModuleOne_progress_label {
    min-width: 60px;
    font-size: 11px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .AiModuleOne_assessment,
  .AiModuleOne_option_correct,
  .AiModuleOne_option_wrong,
  .AiModuleOne_complete_btn::before {
    animation: none;
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/COURSES/AiModules/AiModuleOne/AiModuleOne.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;8DAC8D;AAC9D;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA,6CAA6C;;AAE7C;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,qCAAqC;;AAErC;EACE,WAAW;EACX,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,KAAK,sBAAsB,EAAE;EAC7B,MAAM,sBAAsB,EAAE;EAC9B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,KAAK,wBAAwB,EAAE;EAC/B,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;EAClC,MAAM,2BAA2B,EAAE;EACnC,OAAO,wBAAwB,EAAE;AACnC;;AAEA,0CAA0C;;AAE1C;EACE,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,+HAA+H;EAC/H,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,YAAY;EACZ,uFAAuF;EACvF,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,qCAAqC;;AAErC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;;;;IAIE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".AiModuleOne_wrapper {\n  width: 100%;\n  min-height: 100vh;\n  background: #f6f3ec;\n  box-sizing: border-box;\n  font-family: 'Manrope', sans-serif;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n}\n\n.AiModuleOne_content {\n  width: 100%;\n  max-width: 960px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.AiModuleOne_title {\n  font-size: clamp(20px, 3vw, 27px);\n  font-weight: 800;\n  letter-spacing: -0.3px;\n  color: #241f16;\n  margin: 0 0 8px;\n}\n\n.AiModuleOne_subtitle {\n  font-size: 13.5px;\n  font-weight: 500;\n  color: #8a8478;\n  margin: 0 0 28px;\n  line-height: 1.6;\n}\n\n/* fluid 16:9 responsive video container for the native <video> tag —\n   plays whatever direct file URL your VideoHoster gives you */\n.AiModuleOne_video_wrap {\n  position: relative;\n  width: 100%;\n  padding-top: 56.25%;\n  border-radius: 16px;\n  overflow: hidden;\n  background: #000000;\n  box-shadow: 0 10px 30px rgba(28, 27, 20, 0.14);\n  margin-bottom: 16px;\n}\n\n.AiModuleOne_video {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n  background: #000000;\n}\n\n/* ---------- WATCH PROGRESS BAR ---------- */\n\n.AiModuleOne_progress_row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 32px;\n}\n\n.AiModuleOne_progress_track {\n  flex: 1;\n  height: 8px;\n  border-radius: 100px;\n  background: #e6e3dc;\n  overflow: hidden;\n}\n\n.AiModuleOne_progress_fill {\n  height: 100%;\n  border-radius: 100px;\n  background: linear-gradient(90deg, #ff8a5c, #34c795);\n  transition: width 0.4s ease;\n}\n\n.AiModuleOne_progress_label {\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 800;\n  color: #241f16;\n  min-width: 74px;\n  text-align: right;\n}\n\n/* ---------- ASSESSMENT ---------- */\n\n.AiModuleOne_assessment {\n  width: 100%;\n  text-align: left;\n  animation: AiModuleOne_fadeIn 0.5s ease both;\n}\n\n@keyframes AiModuleOne_fadeIn {\n  from { opacity: 0; transform: translateY(14px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.AiModuleOne_assessment_title {\n  font-size: 18px;\n  font-weight: 800;\n  color: #241f16;\n  margin: 0 0 6px;\n  text-align: center;\n}\n\n.AiModuleOne_assessment_sub {\n  font-size: 13px;\n  font-weight: 500;\n  color: #8a8478;\n  margin: 0 0 24px;\n  text-align: center;\n}\n\n.AiModuleOne_question_card {\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 22px 22px 24px;\n  margin-bottom: 18px;\n  box-shadow: 0 4px 14px rgba(28, 27, 20, 0.06);\n}\n\n.AiModuleOne_question_text {\n  font-size: 14.5px;\n  font-weight: 700;\n  color: #241f16;\n  margin: 0 0 16px;\n  line-height: 1.5;\n}\n\n.AiModuleOne_question_num {\n  color: #ff8a5c;\n  font-weight: 800;\n}\n\n.AiModuleOne_options_grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.AiModuleOne_option_btn {\n  font-family: 'Manrope', sans-serif;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  text-align: left;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1.5px solid #e6e3dc;\n  background: #ffffff;\n  cursor: pointer;\n  transition: border-color 0.2s ease, background 0.2s ease, transform 0.15s ease;\n}\n\n.AiModuleOne_option_btn:hover:not(:disabled) {\n  border-color: #ff8a5c;\n  background: #fff6f1;\n  transform: translateY(-2px);\n}\n\n.AiModuleOne_option_btn:disabled {\n  cursor: not-allowed;\n}\n\n.AiModuleOne_option_key {\n  flex-shrink: 0;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: #f6f3ec;\n  color: #241f16;\n  font-size: 12px;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.AiModuleOne_option_label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #4b5165;\n}\n\n.AiModuleOne_option_correct {\n  border-color: #34c795;\n  background: #eafaf3;\n  animation: AiModuleOne_pop 0.3s ease;\n}\n\n.AiModuleOne_option_correct .AiModuleOne_option_key {\n  background: #34c795;\n  color: #ffffff;\n}\n\n.AiModuleOne_option_correct .AiModuleOne_option_label {\n  color: #1f7a53;\n}\n\n.AiModuleOne_option_wrong {\n  border-color: #d8455c;\n  background: #fdeef0;\n  animation: AiModuleOne_shake 0.35s ease;\n}\n\n.AiModuleOne_option_wrong .AiModuleOne_option_key {\n  background: #d8455c;\n  color: #ffffff;\n}\n\n.AiModuleOne_option_wrong .AiModuleOne_option_label {\n  color: #a3293c;\n}\n\n.AiModuleOne_option_reveal {\n  border-color: #34c795;\n  background: #f4fbf8;\n}\n\n.AiModuleOne_option_reveal .AiModuleOne_option_key {\n  background: #34c795;\n  color: #ffffff;\n}\n\n@keyframes AiModuleOne_pop {\n  0% { transform: scale(0.96); }\n  60% { transform: scale(1.02); }\n  100% { transform: scale(1); }\n}\n\n@keyframes AiModuleOne_shake {\n  0% { transform: translateX(0); }\n  25% { transform: translateX(-4px); }\n  50% { transform: translateX(4px); }\n  75% { transform: translateX(-2px); }\n  100% { transform: translateX(0); }\n}\n\n/* ---------- COMPLETE BUTTON ---------- */\n\n.AiModuleOne_complete_btn {\n  font-family: 'Manrope', sans-serif;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  background: #34c795;\n  color: #ffffff;\n  border: none;\n  border-radius: 100px;\n  padding: 14px 30px;\n  font-size: 13.5px;\n  font-weight: 800;\n  letter-spacing: 0.4px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  margin-top: 8px;\n  transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.25s ease, background 0.25s ease, opacity 0.25s ease;\n  will-change: transform;\n}\n\n.AiModuleOne_complete_btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -60%;\n  width: 50%;\n  height: 100%;\n  background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.5), transparent);\n  transform: skewX(-20deg);\n  transition: left 0.6s ease;\n}\n\n.AiModuleOne_complete_btn:hover:not(:disabled) {\n  background: #241f16;\n  box-shadow: 0 10px 22px rgba(36, 31, 22, 0.22);\n  transform: translateY(-3px) scale(1.02);\n}\n\n.AiModuleOne_complete_btn:hover:not(:disabled)::before {\n  left: 120%;\n}\n\n.AiModuleOne_complete_btn:active:not(:disabled) {\n  transform: translateY(0) scale(0.98);\n}\n\n.AiModuleOne_complete_btn:disabled {\n  background: #cfc9bc;\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n.AiModuleOne_complete_check {\n  display: inline-block;\n  font-weight: 800;\n}\n\n/* ---------- RESPONSIVE ---------- */\n\n@media (max-width: 640px) {\n  .AiModuleOne_wrapper {\n    padding: 36px 18px;\n  }\n\n  .AiModuleOne_video_wrap {\n    border-radius: 12px;\n  }\n\n  .AiModuleOne_options_grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 420px) {\n  .AiModuleOne_question_card {\n    padding: 18px 16px 20px;\n  }\n\n  .AiModuleOne_progress_label {\n    min-width: 60px;\n    font-size: 11px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .AiModuleOne_assessment,\n  .AiModuleOne_option_correct,\n  .AiModuleOne_option_wrong,\n  .AiModuleOne_complete_btn::before {\n    animation: none;\n    transition: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
